import { render, staticRenderFns } from "./PromotionLink.vue?vue&type=template&id=1d6fca08&scoped=true&"
import script from "./PromotionLink.vue?vue&type=script&lang=js&"
export * from "./PromotionLink.vue?vue&type=script&lang=js&"
import style0 from "./PromotionLink.vue?vue&type=style&index=0&id=1d6fca08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6fca08",
  null
  
)

export default component.exports